import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {  FvmsCommonService } from "src/app/shared/service";
import {  DtgListType } from "src/app/shared/vo";

@Component({
  templateUrl: './dtg.analytics.drive.carbon.main.component.html'
  ,providers: []

})
export class DtgAnalyticsDriveCarbonMainComponent implements OnInit,OnDestroy, AfterViewInit {

  isContinue:boolean = true;
  companyInfo:any;
  DtgListType = DtgListType;

  constructor(
    private fvmsCommonService:FvmsCommonService
  ) {

    this.companyInfo = this.fvmsCommonService.getCompanyInfo();

    this.fvmsCommonService.subscribeCompanyInfo()
      .pipe(takeWhile(() => this.isContinue))
      .subscribe(companyInfo => {
        this.companyInfo = companyInfo;
    });


  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.isContinue = false;
  }

  ngAfterViewInit(): void {
  }

}
